import { Pipe, PipeTransform } from '@angular/core';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-angular';

@Pipe({
  name: 'scFieldValue',
  standalone: true,
})
export class ScFieldValuePipe implements PipeTransform {
  transform<T extends { fields: A }, A>(
    rendering: T,
    key: keyof A,
    defaultValue = ''
  ): string {
    return getFieldValue(rendering as any, key as string, defaultValue);
  }
}
